import * as React from "react";
import { Form, Input, Checkbox, InputNumber } from "antd";
import { QualifierFormConstants } from "../../../common/Constants";
import TextArea from "antd/lib/input/TextArea";
import { IFormConfigSectionQualifier } from "../../../model/formconfiguration/FormConfigSectionQualifier";

const FormConfigSectionQualifierForm = ({
  getFieldDecorator,
  translate,
  formConfigSectionQualifier,
  readOnly = false
}: {
  getFieldDecorator: any;
  translate: any;
  formConfigSectionQualifier?: IFormConfigSectionQualifier;
  readOnly?: boolean;
}) => {
  return (
    <Form>
      {
        <Form.Item label={translate("qualifier_form.code")}>
          {getFieldDecorator(QualifierFormConstants.Fields.CODE, {
            initialValue: formConfigSectionQualifier?.qualifierCode,
            rules: [
              {
                required: true,
                message: translate("qualifier_form.required_message", {
                  field: translate("qualifier_form.code")
                })
              }
            ]
          })(
            <Input
              readOnly={formConfigSectionQualifier || readOnly ? true : false}
            />
          )}
        </Form.Item>
      }
      <Form.Item label={translate("qualifier_form.name")}>
        {getFieldDecorator(QualifierFormConstants.Fields.NAME, {
          initialValue: formConfigSectionQualifier?.qualifier?.name,
          rules: [
            {
              required: true,
              message: translate("qualifier_form.required_message", {
                field: translate("qualifier_form.name")
              })
            }
          ]
        })(<Input readOnly={readOnly} />)}
      </Form.Item>
      <Form.Item label={translate("qualifier_form.description")}>
        {getFieldDecorator(
          QualifierFormConstants.Fields.QUALIFIER_DESCRIPTION,
          {
            initialValue: formConfigSectionQualifier?.qualifier?.description,
            rules: [
              {
                required: false,
                message: translate("qualifier_form.required_message", {
                  field: translate("qualifier_form.description")
                })
              }
            ]
          }
        )(
          <TextArea
            readOnly={readOnly}
            autoSize={{ minRows: 3 }}
            maxLength={
              QualifierFormConstants.VALIDATION_RULES.DESCRIPTION_MAX_LENGTH
            }
          />
        )}
      </Form.Item>
      <Form.Item label={translate("qualifier_form.field_required")}>
        {getFieldDecorator(QualifierFormConstants.Fields.REQUIRED, {
          valuePropName: "checked",
          initialValue: formConfigSectionQualifier
            ? formConfigSectionQualifier.required
            : true
        })(<Checkbox disabled={readOnly} />)}
      </Form.Item>
      <Form.Item label={translate("qualifier_form.sql_validation")}>
        {getFieldDecorator(QualifierFormConstants.Fields.SQL_VALIDATION, {
          initialValue: formConfigSectionQualifier?.qualifier?.sqlValidation,
          rules: [
            {
              required: false,
              message: translate("qualifier_form.required_message", {
                field: translate("qualifier_form.sql_validation")
              })
            }
          ]
        })(
          <TextArea
            readOnly={readOnly}
            autoSize={{ minRows: 3 }}
            maxLength={
              QualifierFormConstants.VALIDATION_RULES.DESCRIPTION_MAX_LENGTH
            }
          />
        )}
      </Form.Item>
      <Form.Item label={translate("qualifier_form.max_number")}>
        {getFieldDecorator(QualifierFormConstants.Fields.MAX_NUMBER, {
          initialValue: formConfigSectionQualifier?.qualifier?.maxNumber,
          rules: [
            {
              required: false,
              message: translate("qualifier_form.required_message", {
                field: translate("qualifier_form.max_number")
              })
            }
          ]
        })(<Input readOnly={readOnly} />)}
      </Form.Item>
      {formConfigSectionQualifier && (
        <Form.Item label={translate("qualifier_form.order_number")}>
          {getFieldDecorator(QualifierFormConstants.Fields.ORDER_NUMBER, {
            initialValue: formConfigSectionQualifier?.orderNumber,
            rules: [
              {
                required: true,
                message: translate("qualifier_form.required_message", {
                  field: translate("qualifier_form.orderNumber")
                })
              }
            ]
          })(<Input readOnly={readOnly} />)}
        </Form.Item>
      )}
      {formConfigSectionQualifier && (
        <Form.Item label={translate("qualifier_form.order_number_visible")}>
          {getFieldDecorator(
            QualifierFormConstants.Fields.ORDER_NUMBER_VISIBLE,
            {
              valuePropName: "checked",
              initialValue: formConfigSectionQualifier
                ? formConfigSectionQualifier.orderNumberVisible
                : false,
              rules: [
                {
                  required: true,
                  message: translate("qualifier_form.required_message", {
                    field: translate("qualifier_form.orderNumberVisible")
                  })
                }
              ]
            }
          )(<Checkbox disabled={readOnly} />)}
        </Form.Item>
      )}
      {formConfigSectionQualifier && (
        <Form.Item label={translate("qualifier_form.label")}>
          {getFieldDecorator(QualifierFormConstants.Fields.LABEL, {
            initialValue: formConfigSectionQualifier?.label,
            rules: [
              {
                required: false,
                message: translate("qualifier_form.required_message", {
                  field: translate("qualifier_form.label")
                })
              }
            ]
          })(<Input readOnly={readOnly} />)}
        </Form.Item>
      )}
      {formConfigSectionQualifier && (
        <Form.Item label={translate("qualifier_form.label_visible")}>
          {getFieldDecorator(QualifierFormConstants.Fields.LABEL_VISIBLE, {
            valuePropName: "checked",
            initialValue: formConfigSectionQualifier
              ? formConfigSectionQualifier.labelVisible
              : false,
            rules: [
              {
                required: true,
                message: translate("qualifier_form.required_message", {
                  field: translate("qualifier_form.label_visible")
                })
              }
            ]
          })(<Checkbox disabled={readOnly} />)}
        </Form.Item>
      )}
      {formConfigSectionQualifier && (
        <Form.Item
          label={translate("qualifier_form.form_section_qualifier_description")}
        >
          {getFieldDecorator(
            QualifierFormConstants.Fields.FORM_SECTION_QUALIFIER_DESCRIPTION,
            {
              initialValue: formConfigSectionQualifier?.description,
              rules: [
                {
                  required: false,
                  message: translate("qualifier_form.required_message", {
                    field: translate(
                      "qualifier_form.form_section_qualifier_description"
                    )
                  })
                }
              ]
            }
          )(
            <TextArea
              readOnly={readOnly}
              autoSize={{ minRows: 3 }}
              maxLength={
                QualifierFormConstants.VALIDATION_RULES
                  .FORM_SECTION_QUALIFIER_DESCRIPTION_MAX_LENGTH
              }
            />
          )}
        </Form.Item>
      )}
      {formConfigSectionQualifier && (
        <Form.Item label={translate("qualifier_form.additional_commnet")}>
          {getFieldDecorator(QualifierFormConstants.Fields.ADDITIONAL_COMMENT, {
            initialValue: formConfigSectionQualifier?.additionalComment,
            rules: [
              {
                required: false,
                message: translate("qualifier_form.required_message", {
                  field: translate("qualifier_form.additional_commnet")
                })
              }
            ]
          })(
            <TextArea
              readOnly={readOnly}
              autoSize={{ minRows: 3 }}
              maxLength={
                QualifierFormConstants.VALIDATION_RULES
                  .ADDITIONAL_COMMENT_MAX_LENGTH
              }
            />
          )}
        </Form.Item>
      )}
      {formConfigSectionQualifier && (
        <Form.Item label={translate("qualifier_form.error_code")}>
          {getFieldDecorator(QualifierFormConstants.Fields.ERROR_CODE, {
            initialValue: formConfigSectionQualifier?.errorCode,
            rules: [
              {
                required: false,
                message: translate("qualifier_form.required_message", {
                  field: translate("qualifier_form.error_code")
                })
              }
            ]
          })(<Input readOnly={readOnly} />)}
        </Form.Item>
      )}
      {formConfigSectionQualifier && (
        <Form.Item label={translate("qualifier_form.tooltip")}>
          {getFieldDecorator(QualifierFormConstants.Fields.TOOLTIP, {
            initialValue: formConfigSectionQualifier?.tooltip,
            rules: [
              {
                required: false,
                message: translate("qualifier_form.required_message", {
                  field: translate("qualifier_form.tooltip")
                })
              }
            ]
          })(
            <TextArea
              readOnly={readOnly}
              autoSize={{ minRows: 3 }}
              maxLength={
                QualifierFormConstants.VALIDATION_RULES.TOOLTIP_MAX_LENGTH
              }
            />
          )}
        </Form.Item>
      )}
      {/* {formConfigSectionQualifier && (
        <Form.Item  label={translate("qualifier_form.visible_public")}>
          {getFieldDecorator(QualifierFormConstants.Fields.VISIBLE_PUBLIC, {
            valuePropName: "checked",
            initialValue: formConfigSectionQualifier
              ? formConfigSectionQualifier.visiblePublic
              : false,
            rules: [
              {
                required: true,
                message: translate("qualifier_form.required_message", {
                  field: translate("qualifier_form.visible_public")
                })
              }
            ]
          })(<Checkbox disabled={readOnly} />)}
        </Form.Item>
      )} */}
      <Form.Item label={translate("qualifier_form.width")}>
        {getFieldDecorator(QualifierFormConstants.Fields.WIDTH, {
          initialValue: formConfigSectionQualifier?.width,
          rules: [
            {
              required: false,
              message: translate("qualifier_form.required_message", {
                field: translate("qualifier_form.visible_public")
              })
            }
          ]
        })(<InputNumber readOnly={readOnly} />)}
      </Form.Item>
    </Form>
  );
};

export default FormConfigSectionQualifierForm;
